import { ChangeDetectionStrategy, Component } from '@angular/core';
import { getStateCourt } from '@shared/utils';

@Component({
  selector: 'app-toolbar-title',
  templateUrl: './toolbar-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarTitleComponent {
  protected readonly court = getStateCourt();
}
